<template>
    <el-dialog
        v-bind="$attrs"
        v-on="$listeners"
        :width="result ? bodyWidth + 40 + 'px' : '421px'"
        class="dialog-common"
        append-to-body
        title="安全验证"
        :show-close="true"
        :close-on-click-modal="false"
        @open="openCb"
    >
        <div class="verify-body">
            <div
                class="text-verify"
                v-if="result"
                ref="textRef"
                :style="{
                    width: bodyWidth + 'px',
                    height: bodyHeight + 'px',
                    backgroundImage: `url(${result.backgroundImage})`,
                }"
                @click="clickImg"
            >
                <span
                    v-for="(item, i) in clickData"
                    :key="i"
                    class="text-verify-select"
                    :style="{
                        left: item.x - 10 + 'px',
                        top: item.y - 10 + 'px',
                    }"
                    >{{ i + 1 }}</span
                >
            </div>
            <div class="text-info">
                <span>请依次点击右侧图中的文字</span>
                <img
                    v-if="result"
                    :src="result.templateImage"
                    alt=""
                    :style="{ width: result.templateImageWidth / 3 + 'px' }"
                />
            </div>
        </div>
        <div slot="footer">
            <el-button class="ems-btn ems-btn-opt" plain @click="refresh">刷新</el-button>
            <el-button class="ems-btn ems-btn-opt" type="primary" @click="check">验证</el-button>
        </div>
    </el-dialog>
</template>
<script>
import commonApi from "@/server/common";
import { debounce } from "lodash";
import { encryptAES } from "@/utils/aes";

export default {
    name: "ClickVerify",
    props: {},
    data() {
        return {
            result: null,
            clickData: [], //已经点击了文字坐标
            bodyWidth: 0,
            bodyHeight: 0,
            // originx: 0,
            // originy: 0
        };
    },
    methods: {
        openCb() {
            if (this.clickData.length > 0) {
                this.clickData = [];
            }
            this.init();
        },
        init() {
            commonApi.getPictureNew().then((res) => {
                this.result = res.data;
                // let originx = res.data.data.percentage.split(';')[0].split(',')

                // this.originx = Number(originx[0])
                // this.originy = Number(originx[1])
                // console.log('originx', this.originx);
                // console.log('originy', this.originy);

                this.cid = res.data.id;
                this.$emit("updateCid", res.data.id);
                this.bodyWidth = Number(
                    (res.data.backgroundImageWidth / 1.4).toFixed(2)
                );
                this.bodyHeight = Number(
                    (res.data.backgroundImageHeight / 1.4).toFixed(2)
                );
            });
        },
        clickImg(evt) {
            const x = evt.offsetX;
            const y = evt.offsetY;
            const i = this.clickData.length + 1;
            if (i > 4) {
                return;
            }
            const d = {
                x,
                y,
                t: i * 100,
            };
            this.clickData.push(d);
        },
        // clickImg(evt) {
        //     const x = evt.offsetX;
        //     const y = evt.offsetY;
        //     this.clickData.push({
        //         x,
        //         y
        //     })
        //     const offsetx = Math.abs(Number((x / this.bodyWidth).toFixed(8)) - this.originx)
        //     const offsety = Math.abs(Number((y / this.bodyHeight).toFixed(8)) - this.originy)
        //     console.log('x', x, offsetx);
        //     console.log('y', y, offsety);

        // },
        refresh: debounce(function() {
            if (this.clickData.length > 0) {
                this.clickData = [];
            }
            this.init();
        }, 100),
        check() {
            let track = this.clickData.map((item) => ({
                x: Number((item.x / this.bodyWidth).toFixed(8)),
                y: Number((item.y / this.bodyHeight).toFixed(8)),
                t: item.t,
            }));
            // // track = encryptAES(JSON.stringify(track))
            // commonApi.checkcapcodeNew({
            //     value: {
            //         trackList: track,
            //         id: this.cid,
            //     },
            // }).then(res => {
            //     this.$emit('success', track)
            //     this.$emit('update:visible', false)
            // }).catch(_ => {
            //     this.refresh()
            // })
            this.$emit("success", track);
            this.$emit("update:visible", false);
        },
    },
};
</script>
<style scoped lang="scss">
// .verify-body {
//     padding-top: 20px;
// }
.text-verify {
    background: center / 100% no-repeat;
    position: relative;
    cursor: pointer;
    margin: 0 auto 20px;
}
.text-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
}

</style>
<style>
.text-verify-select {
    position: absolute;
    color: #fff;
    width: 20px;
    height: 20px;
    text-align: center;
    background-color: #f5222d;
    border-radius: 50%;
}
</style>
